import { LaunchDarkly } from './launch-darkly.model';

export const environment = {
  production: true,
  apiUrl:
    'https://wa-capstone-patient-portal-api-dev-dbbehyb7aadjcvcv.australiaeast-01.azurewebsites.net',
  secret: 'sckLhaeYwQVLeAsvEDVXFwoWdPFlEXgLuLpluljFPrNBcaMnyl',
  version: 'V 0.1.0:R2',

  launchDarkly: {
    EnableLogin: false,
  } as LaunchDarkly,

  applicationInsights: {
    connectionString:
      'InstrumentationKey=7f5efeb7-3b96-4fc9-9179-a2bdf274201e;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/;ApplicationId=16c2e305-e600-4685-8c3a-3dc2598aaf0a',
    instrumentationKey: '7f5efeb7-3b96-4fc9-9179-a2bdf274201e',
  },
};
